import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Plans from "@/components/Plans";
import TimePreference from "@/components/TimePreference";
import TimePreference2 from "@/components/TimePreference2";
import TestCall from "@/components/TestCall";
import CallHistory from "@/components/CallHistory";
import Settings from "@/components/Settings";
import { Toaster } from "@/components/ui/toaster";
import Index from "@/pages/Index";
import Login from "@/pages/Login";
import SubscriberRegistration from "@/components/SubscriberRegistration";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<SubscriberRegistration />} />
        <Route path="/plans" element={<Plans />} />
        <Route path="/time-preference" element={<TimePreference />} />
        <Route path="/time-preference-2" element={<TimePreference2 />} />
        <Route path="/test-call" element={<TestCall />} />
        <Route path="/call-history" element={<CallHistory />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
      <Toaster />
    </Router>
  );
}

export default App;